import { render, staticRenderFns } from "./LookMore.vue?vue&type=template&id=fc4ae406&scoped=true"
import script from "./LookMore.vue?vue&type=script&lang=js"
export * from "./LookMore.vue?vue&type=script&lang=js"
import style0 from "./LookMore.vue?vue&type=style&index=0&id=fc4ae406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4ae406",
  null
  
)

export default component.exports